import script from "./LegalAssistantView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegalAssistantView.vue?vue&type=script&setup=true&lang=ts"

import "./LegalAssistantView.vue?vue&type=style&index=0&id=1626e590&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1626e590"]])

export default __exports__